export default "__VITE_ASSET__CVa6zNfo__"